// Способы входа проекта из `options.auth` (global.config.js → store.core.state.options).
//
//   email: { password, code }   вход по почте и чем его подтверждать
//   phone: { password, code }   вход по телефону и чем его подтверждать
//
// Схема — как у Logto (идентификатор + password / verificationCode) и Supabase
// (`[auth.email]`, `[auth.sms]`): идентификатор задаёт, кем человек себя
// называет, `password` и `code` — чем он это доказывает. Пароль — опция
// идентификатора, а не отдельный вид входа. Внешние провайдеры (Google и т. п.)
// встанут соседним ключом `external`, когда появится серверный OAuth.
//
// Нет ни `email`, ни `phone` — почта и телефон с паролем: так формы работали до
// этой настройки. Идентификатор без пароля и без кода войти не даёт и считается
// выключенным.
//
// Возвращает { phone?, email? } — только включённые, в порядке вкладок формы.
const identifiers = ['phone', 'email']

export function resolveAuthMethods(options = {}) {
  const configured = identifiers.some(identifier => options[identifier])
  const methods = {}

  for (const identifier of identifiers) {
    const value = configured ? options[identifier] : { password: true, code: false }
    if (!value) continue

    const password = Boolean(value.password)
    const code = Boolean(value.code)

    if (!password && !code) {
      console.warn(`[auth] ${identifier}: нет ни пароля, ни кода — вход по нему выключен`)
      continue
    }

    methods[identifier] = { password, code }
  }

  return methods
}
